export const CURRENCY_SYMBOLS = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    BRL: 'R$',
    INR: '₹',
    CAD: 'CA$',
    AUD: 'AU$'
} as const;

export type CurrencyType = keyof typeof CURRENCY_SYMBOLS;

export const FREQUENCIES = {
    YEARLY: 'yearly',
    MONTHLY: 'monthly'
} as const;

export type PlanFrequencyType = (typeof FREQUENCIES)[keyof typeof FREQUENCIES];
